import { render, staticRenderFns } from "./Coating.vue?vue&type=template&id=3ff5231c&scoped=true&"
import script from "./Coating.vue?vue&type=script&lang=js&"
export * from "./Coating.vue?vue&type=script&lang=js&"
import style0 from "./Coating.vue?vue&type=style&index=0&id=3ff5231c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5231c",
  null
  
)

export default component.exports